 <template>
  <footer class="page-footer transparent">
    <div class="footer-copyright">
      <div class="container">
        <span class="red-text text-darken-4">
          © <span class="hide-on-small-only">Copyright</span>
          <strong class="black-text text-lighten-3">inHouse S.A.S</strong>
          <span class="hide-on-med-and-down">Todos los derechos reservados.</span>
        </span>
        <span class="red-text text-darken-4 right">
          Desarrollado con
          <i class="fa fa-heart red-text text-darken-4"> </i>
          <a href="http://mr.daza.com.co" target="_blank" class="black-text">MrDaza</a>
          {{info_date}}
        </span>
      </div>
    </div>
  </footer>
</template>
<script>
import moment from "moment";
export default {
  name: "Footer",
  data() {
    moment.locale('es_CO');
    return {
      info_date: moment().format("YYYY")
    };
  }
};
</script>

            


// WEBPACK FOOTER //
// src/components/elements/Footer.vue